module.exports = __webpack_public_path__ + "img/chirpnoteslogo-v1.3a1db1fb.png";